import React, { useEffect, useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isValNull, getPath, isEmpty } from "../../../utils";
import * as LifeLineAction from "../../../store/actions/LifeLine";
import * as UserActions from "../../../store/actions/User";
import NoFooterModal from "../../Common/NoFooterModal";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../../components/Common/PaginatedReactDropdown";

const SupportActions = (props) => {
  const { orderId, setStatus } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    actionName: "",
    activeActionReason: "",
    actionReasonsList: [],
    comments: "",
    reasonIdMapping: {},
  });

  const actionKeyMap = {
    cancel: "CANCEL",
    force_complete: "FORCE COMPLETE",
    reassign: "REASSIGN",
  };

  const handleorderActionClick = () => {
    const isReasonsListEmpty = isEmpty(modalContent.actionReasonsList);
    if (isValNull(modalContent.activeActionReason) && !isReasonsListEmpty) {
      setStatus({
        type: "error",
        message: "Please select action reason",
      });
    } else if (
      modalContent.comments === "" ||
      modalContent.comments === undefined ||
      modalContent.comments === null
    ) {
      setStatus({
        type: "error",
        message: "Please enter comments",
      });
    } else {
      const reasonId = isReasonsListEmpty
        ? 0
        : [
            ...Object.entries(
              getPath(modalContent.reasonIdMapping, modalContent.actionName)
            ),
          ].find(
            ([id, reason]) => reason === modalContent.activeActionReason
          )[0];
      props
        .orderActions(
          modalContent.actionName,
          orderId,
          parseInt(reasonId),
          modalContent.comments
        )
        .then((res) => {
          if (res && getPath(res, "message", "").length != 0) {
            setStatus({
              type: "success",
              message: getPath(res, "message", res.message),
            });
            window.location.reload();
          } else {
            setStatus({
              type: "error",
              message: "Error occured while performing the action!",
            });
          }
        });
      setShowModal(false);
    }
  };

  const handleDoClick = (action) => {
    props.actionReasonsMapping().then((res) => {
      if (res) {
        setModalContent((prevModalContent) => ({
          ...prevModalContent,
          reasonIdMapping: getPath(res, "action_reasons", {}),
          actionName: action,
        }));
        setAnchorEl(null);
        setShowModal(true);
      } else {
        setStatus({
          type: "error",
          message: "Error while fetching action reasons",
        });
      }
    });
  };

  useEffect(() => {
    if (modalContent.reasonIdMapping) {
      setModalContent((prevModalContent) => ({
        ...prevModalContent,
        actionReasonsList: Object.values(
          getPath(modalContent.reasonIdMapping, modalContent.actionName, [])
        ),
      }));
    }
  }, [modalContent.actionName]);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (key, value) => {
    setModalContent((prevState) => {
      return { ...prevState, [key]: value };
    });
  };

  const getInputLabel = (val, options, fromKey) => {
    options.find((item) => {
      return item[fromKey] === val;
    });
  };

  return [
    <div>
      <MoreVertIcon onClick={handleMenuOpen} style={{ cursor: "pointer" }} />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        disableAutoFocusItem={true}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={() => handleDoClick("cancel")}>Cancel</MenuItem>
        <MenuItem onClick={() => handleDoClick("force_complete")}>
          Force Complete
        </MenuItem>
        <MenuItem onClick={() => handleDoClick("reassign")}>
          Reassign Delivery Partner
        </MenuItem>
      </Menu>
    </div>,
    <>
      {showModal && (
        <NoFooterModal
          header={true}
          heading={`${"Order Action"}`}
          handleClose={handleClose}
          modalButtons={
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              onClick={() => handleorderActionClick()}
            >
              Submit
            </Button>
          }
        >
          <Input
            value={actionKeyMap[modalContent.actionName]}
            data-testid="actionName"
            id="sushi-input"
            disabled
            label="Action Name"
          />

          {!isEmpty(modalContent.actionReasonsList) && (
            <PaginatedReactDropdown
              options={modalContent.actionReasonsList}
              data-testid="ActionReasonDropDown"
              labelKey="label"
              valueKey="value"
              labelWidth="20%"
              value={getInputLabel(
                modalContent.activeActionReason,
                modalContent.actionReasonsList,
                "key",
                "label"
              )}
              handleChange={handleChange}
              keyToChange="activeActionReason"
              placeholder="Action Reason*"
              showCross={false}
              id="ActionReasonDropDown"
            />
          )}
          <Input
            value={modalContent.comments}
            data-testid="ActionComments"
            id="sushi-input"
            onChange={(e) => handleChange("comments", e)}
            label="Comments*"
          />
        </NoFooterModal>
      )}
    </>,
  ];
};

const mapDispatchToProps = (dispatch) => ({
  setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  orderActions: bindActionCreators(LifeLineAction.OrderActions, dispatch),
  actionReasonsMapping: bindActionCreators(
    LifeLineAction.ActionReasons,
    dispatch
  ),
});

export default connect(null, mapDispatchToProps)(SupportActions);
